import React from 'react';
import { PRIVACY_URL, STORE_URL, SUPPORT_EMAIL, SUPPORT_MAILTO, TERMS_URL } from '../../data/site';
const links = [{
  label: 'Store',
  href: STORE_URL
}, {
  label: 'Terms',
  href: TERMS_URL
}, {
  label: 'Privacy',
  href: PRIVACY_URL
}];
export function Footer() {
  return <footer className="bg-ink pb-28 pt-12 text-white md:pb-12" data-id="element-52" data-mp="5nchdis7j9ii">
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-53" data-mp="5mt0m5eamr62">
        <div className="flex flex-col items-center gap-6 text-center md:flex-row md:justify-between md:text-left" data-id="element-54" data-mp="o99zror8r7d">
          <div data-id="element-55" data-mp="3s1vk2i7tl095">
            <p className="font-display text-[26px] font-bold uppercase leading-none" data-id="element-56" data-mp="3s1ccnvfspu9d">
              Badminton <span className="text-gold" data-id="element-57" data-mp="3n43vny6dvw9p">Class Ready</span>
            </p>
            <p className="mt-2 text-base text-white/70" data-id="element-58" data-mp="3j30bizhaze2o">
              Support:{' '}
              <a href={SUPPORT_MAILTO} className="font-bold text-white underline underline-offset-4 hover:text-gold" data-id="element-59" data-mp="3e35ml1h38yk9">
                {SUPPORT_EMAIL}
              </a>
            </p>
          </div>
          <nav aria-label="Footer" data-id="element-60" data-mp="2kcuvt3985551">
            <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-61" data-mp="2kbjpavoe9ja8">
              {links.map(link => <li key={link.label} data-id="element-62" data-mp="2p5xtnnl1b0r1">
                  <a href={link.href} className="inline-flex min-h-[44px] items-center text-base text-white/80 hover:text-gold" data-id="element-63" data-mp="2bcyc7g1oywgu">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>
        <p className="mt-8 border-t border-white/10 pt-6 text-center text-sm text-white/60 md:text-left" data-id="element-64" data-mp="33yzor8ntd0al">
          © 2026 Badminton Class Ready. Prices in USD. Independent resource; not affiliated with or endorsed by BWF or Shuttle Time.
        </p>
      </div>
    </footer>;
}